'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Navi = void 0;
var $ = require("jquery");
var Navi = /** @class */ (function () {
    function Navi() {
        if ($('.trigOpenSpNavi').length > 0) {
            $(document).on('click', '.trigOpenSpNavi', function () {
                var isOpen = $('.paramOpenSpNavi').attr('data-is-open');
                console.log('hoge');
                if (isOpen === '1') {
                    $('.paramOpenSpNavi').attr('data-is-open', 0);
                    $('.bulletOpenSpNavi').removeClass('show');
                }
                else {
                    $('.paramOpenSpNavi').attr('data-is-open', 1);
                    $('.bulletOpenSpNavi').addClass('show');
                }
            });
        }
    }
    return Navi;
}());
exports.Navi = Navi;
exports.default = Navi;
